import { createAction } from '@reduxjs/toolkit';

export const INITIATE_RECONNECT_ACTION_TYPE = 'saga/initiateReconnect';
export const initiateReconnectAction = createAction(INITIATE_RECONNECT_ACTION_TYPE);
